<template>
  <b-container class="container-field">
    <b-row>
      <b-table-simple hover small caption-top responsive>
        <b-thead>
          <b-tr>
            <b-th v-for="field in tableFieldsCampos" :key="field.key">
              {{ field.label }}
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <template v-for="row in fillActiveList">
            <!-- {{row}} -->
            <b-tr>
              <b-td>
                {{ row.item.sequenciaExibicao }}
                <!-- /{{row.item.id}} -->
              </b-td>
              <b-td>
                <b-form-input
                  class="input-name"
                  type="text"
                  v-model="row.item.nome"
                  required
                />
              </b-td>
              <b-td>
                <b-form-select
                  class="select-field"
                  :options="options"
                  v-model="row.item.tipo"
                ></b-form-select>
              </b-td>

              <b-td>
                <div v-if="canShowObrigatoryOption(row.item)">
                  <div v-if="row.item.tipo == 10 || row.item.tipo == 11">
                    <b-form-select
                      class="select-boolean"
                      :options="optionsBoolean"
                      v-model="row.item.isMandatoryAttachment"
                    ></b-form-select>
                  </div>
                  <div v-else>
                    <b-form-select
                      class="select-boolean"
                      :options="optionsBoolean"
                      v-model="row.item.obrigatorio"
                    ></b-form-select>
                  </div>
                </div>
              </b-td>

              <b-td>
                <b-form-input
                  v-if="canShowTipOption(row.item)"
                  class="input-tip"
                  type="text"
                  v-model="row.item.dica"
                ></b-form-input>
              </b-td>

              <b-td style="min-width: 250px">
                <table-form-resequence
                  class="d-inline"
                  :item="row.item"
                  :items="items"
                  :display-name="row.item.nome"
                  :title="$t('checklist.form.fieldResequence')"
                  v-b-tooltip.hover
                ></table-form-resequence>
                <b-button
                  class="ml-1"
                  size="sm"
                  :title="$t('checklist.form.fieldDelete')"
                  v-b-tooltip.hover
                  @click="deleteField(row)"
                >
                  X
                </b-button>
                <b-button
                  size="sm"
                  class="ml-1"
                  :title="$t('checklist.form.fieldClone')"
                  v-b-tooltip.hover
                  @click="cloneField(row.item, items)"
                >
                  <i class="tim-icons icon-single-copy-04"></i>
                </b-button>
                <b-button
                  size="sm"
                  class="ml-1"
                  :title="$t('checklist.form.fieldConfigShow')"
                  v-b-tooltip.hover
                  @click="displayConfig(row)"
                >
                  <i class="tim-icons icon-settings-gear-63"></i>
                </b-button>
                <b-button
                  :disabled="row.item.tipo != 7 && row.item.tipo != 13"
                  size="sm"
                  class="ml-1"
                  :title="$t('checklist.form.fieldValuesShow')"
                  v-b-tooltip.hover
                  @click="row.detailsShowing = !row.detailsShowing"
                >
                  <i
                    v-if="row.detailsShowing"
                    class="tim-icons icon-simple-delete"
                  ></i>
                  <i v-else class="tim-icons icon-simple-add"></i>
                </b-button>
              </b-td>
            </b-tr>

            <b-tr class="b-table-details" v-show="row.item.tipo == 8">
              <b-td :colspan="tableFieldsCampos.length">
                <div>
                  <b-form-group
                    :label="$t('checklist.form.fieldAnnotationDescription')"
                    label-for="input-annotation-description"
                    class="fileOnlyAttachment"
                    label-cols-sm="-2"
                  >
                    <b-form-textarea
                      id="input-annotation-description"
                      v-model="row.item.defaultValue"
                      style="height: 10rem"
                    ></b-form-textarea>
                  </b-form-group>
                </div>

                <field-tip-attachments :field="row.item" />
              </b-td>
            </b-tr>

            <b-tr class="b-table-details" v-if="row.configShowing">
              <b-td :colspan="tableFieldsCampos.length">
                <b-card>
                  <b-row>
                    <b-col cols="4">
                      <div v-if="row.item.tipo == 14">
                        <b-form-group
                          v-if="canShowAttachmentOption(row.item)"
                          label="Perfil responsável"
                          label-for="permiteAnexo"
                        >
                          <multiselect
                            id="selectSteps"
                            class="select-field"
                            v-model="row.item.responsible"
                            label="text"
                            track-by="value"
                            placeholder="Selecione os perfis"
                            :close-on-select="false"
                            :showLabels="false"
                            :multiple="true"
                            :options="profileOptions"
                          >
                          </multiselect>
                          <!-- {{ profileOptions }} -->
                        </b-form-group>
                      </div>

                      <div v-if="row.item.tipo == 20">
                        <b-form-group
                          v-if="canShowAttachmentOption(row.item)"
                          label="Tipo do Equipamento"
                          label-for="vehicleType"
                        >
                          <multiselect
                            id="selectSteps"
                            class="select-field"
                            v-model="row.item.vehicle"
                            label="text"
                            track-by="value"
                            placeholder="Selecione os perfis"
                            :close-on-select="false"
                            :showLabels="false"
                            :multiple="true"
                            :options="vehicleOptions"
                          >
                          </multiselect>
                          <!-- {{ row.item.vehicle }} -->
                        </b-form-group>
                      </div>
                      <div v-if="row.item.tipo == 21">
                        <b-row sm="12" md="2">
                          <b-col cols="7">
                            <b-form-group
                              v-if="canShowAttachmentOption(row.item)"
                              label="Reconhecimento de texto [OCR]"
                              label-for="ocrType"
                            >
                              <single-select
                                :value.sync="row.item.ocrType"
                                :value-property="'value'"
                                :options="ocrOptions"
                                :placeholder="'Selecione o tipo de leitura'"
                              />

                              <!-- {{ row.item.ocrType }} -->
                            </b-form-group>
                          </b-col>
                          <b-col>
                            <b-form-group
                              :label="'Modo de entrada mobile'"
                              label-for="isMandatoryAttachment"
                              :title="'Modo de entrada mobile'"
                              v-b-tooltip.hover
                            >
                              <div>
                                <b-form-select
                                  id="isMandatoryAttachment"
                                  class="select-boolean"
                                  :options="mobileInputOptions"
                                  v-model="row.item.attachmentMobileMode"
                                >
                                </b-form-select>
                              </div>
                            </b-form-group>
                          </b-col>

                          <b-col>
                            <b-form-group
                              :label="'Modo de entrada mobile'"
                              label-for="isMandatoryAttachment"
                              :title="'Modo de entrada mobile'"
                              v-b-tooltip.hover
                            >
                              <div>
                                <b-form-select
                                  id="isMandatoryAttachment"
                                  class="select-boolean"
                                  :options="mobileInputOptions"
                                  v-model="row.item.attachmentMobileMode"
                                >
                                </b-form-select>
                              </div>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12" md="2">
                      <div
                        v-if="
                          row.item.tipo != 22 &&
                          row.item.tipo != 21 &&
                          row.item.tipo != 10 &&
                          row.item.tipo != 11 &&
                          row.item.tipo != 9
                        "
                      >
                        <b-form-group
                          v-if="canShowAttachmentOption(row.item)"
                          label="Permite anexo"
                          label-for="permiteAnexo"
                        >
                          <b-form-select
                            id="permiteAnexo"
                            :options="optionsBoolean"
                            v-model="row.item.permiteAnexo"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </b-col>
                    <b-col sm="12" md="2">
                      <b-form-group
                        v-if="row.item.permiteAnexo == true"
                        label="Anexo obrigatório"
                        label-for="isMandatoryAttachment"
                      >
                        <div v-if="row.item.tipo == 10 || row.item.tipo == 11">
                          <b-form-select
                            id="isMandatoryAttachment"
                            class="select-boolean"
                            :options="optionsBoolean"
                            :disabled="true"
                            v-model="row.item.isMandatoryAttachment"
                          >
                          </b-form-select>
                        </div>
                        <div v-else>
                          <b-form-select
                            id="isMandatoryAttachment"
                            class="select-boolean"
                            :options="optionsBoolean"
                            v-model="row.item.isMandatoryAttachment"
                          >
                          </b-form-select>
                        </div>
                      </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                      <b-form-group
                        v-if="
                          row.item.permiteAnexo == true || row.item.tipo == 10
                        "
                        :label="$t('checklist.form.attachmentMobileMode')"
                        label-for="isMandatoryAttachment"
                        :title="$t('checklist.form.inputMobileAttachemnt')"
                        v-b-tooltip.hover
                      >
                        <div>
                          <b-form-select
                            id="isMandatoryAttachment"
                            class="select-boolean"
                            :options="mobileInputOptions"
                            v-model="row.item.attachmentMobileMode"
                          >
                          </b-form-select>
                        </div>
                      </b-form-group>
                    </b-col>

                    <!-- ##################### PERMITE DOCUMENTOS ################################################ -->
                    <b-col sm="12" md="2" v-if="configuration.allowsDocuments">
                      <b-form-group
                        v-if="
                          row.item.permiteAnexo == true || row.item.tipo == 10
                        "
                        :label="$t('checklist.form.allowsDocuments')"
                        label-for="allowsDocuments"
                        :title="$t('checklist.form.allowsDocuments')"
                        v-b-tooltip.hover
                      >
                        <div>
                          <b-form-select
                            id="allowsDocuments"
                            class="select-boolean"
                            :options="optionsBoolean"
                            v-model="row.item.allowsDocuments"
                          >
                          </b-form-select>
                        </div>
                      </b-form-group>
                    </b-col>

                    <!-- #################### PERMITE VIDEO ################################################################# -->
                    <b-col sm="12" md="2" v-if="configuration.allowsVideo">
                      <b-form-group
                        v-if="
                          row.item.permiteAnexo == true || row.item.tipo == 10
                        "
                        :label="$t('checklist.form.allowsVideo')"
                        label-for="allowsVideo"
                        :title="$t('checklist.form.allowsVideo')"
                        v-b-tooltip.hover
                      >
                        <div>
                          <b-form-select
                            id="allowsVideo"
                            class="select-boolean"
                            :options="optionsBoolean"
                            v-model="row.item.allowsVideo"
                          >
                          </b-form-select>
                        </div>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <div
                    v-if="
                      row.item.tipo == 10 ||
                      row.item.tipo == 11 ||
                      row.item.tipo == 22
                    "
                  ></div>
                  <div v-else>
                    <b-row>
                      <b-col sm="12" md="2">
                        <b-form-group
                          v-if="canShowPendencyOption(row.item)"
                          label="Gera pendência"
                          label-for="geraAnomalia"
                        >
                          <b-form-select
                            id="geraAnomalia"
                            class="select-boolean"
                            :options="optionsAnomaly"
                            v-model="row.item.geraAnomalia"
                          ></b-form-select>
                        </b-form-group>
                      </b-col>
                      <b-col sm="12" md="2">
                        <b-form-group
                          v-if="row.item.geraAnomalia != 1"
                          label="Prioridade"
                          label-for="pendencyPriority"
                        >
                          <pendency-priority-dropdown
                            id="pendencyPriority"
                            class="select-boolean"
                            :model.sync="row.item.pendencyPriority"
                          >
                          </pendency-priority-dropdown>
                        </b-form-group>
                      </b-col>
                      <b-col sm="12" md="3">
                        <b-form-group
                          v-if="row.item.geraAnomalia != 1"
                          label="Pendências únicas"
                          label-for="pendencyUniqueOpened"
                        >
                          <pendency-unique-opened-dropdown
                            id="pendencyUniqueOpened"
                            class="select-boolean"
                            :model.sync="row.item.pendencyUniqueOpened"
                          >
                          </pendency-unique-opened-dropdown>
                        </b-form-group>
                      </b-col>
                      <b-col sm="12" md="2">
                        <b-form-group
                          v-if="row.item.geraAnomalia != 1"
                          label="Notificar geração"
                          label-for="pendencyGenerationNotify"
                        >
                          <pendency-generation-notify-dropdown
                            id="pendencyGenerationNotify"
                            class="select-boolean"
                            :model.sync="row.item.pendencyGenerationNotify"
                          >
                          </pendency-generation-notify-dropdown>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="12" md="4">
                        <b-form-group
                          v-if="row.item.geraAnomalia != 1"
                          :label="$t('checklist.form.profilesPendencyApprover')"
                          label-for="profilesPendencyApprover"
                        >
                          <multiselect
                            id="profilesPendencyApprover"
                            class="select-field"
                            v-model="row.item.profilesApprover"
                            label="displayName"
                            track-by="id"
                            :placeholder="
                              $t('checklist.form.profilesPendencyApprover')
                            "
                            :close-on-select="false"
                            :showLabels="false"
                            :multiple="true"
                            :options="profiles"
                          >
                          </multiselect>
                        </b-form-group>
                      </b-col>
                      <b-col sm="12" md="4">
                        <b-form-group
                          v-if="row.item.geraAnomalia != 1"
                          :label="$t('checklist.form.profilesPendencyViewer')"
                          label-for="profilesPendencyViewer"
                        >
                          <multiselect
                            id="profilesPendencyViewer"
                            class="select-field"
                            v-model="row.item.profilesViewer"
                            label="displayName"
                            track-by="id"
                            :placeholder="
                              $t('checklist.form.profilesPendencyViewer')
                            "
                            :close-on-select="false"
                            :showLabels="false"
                            :multiple="true"
                            :options="profiles"
                          >
                          </multiselect>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <div v-if="row.item.geraAnomalia == 2">
                      <pendency-due-date-crud
                        :dueDate.sync="row.item.pendencyDueDate"
                      ></pendency-due-date-crud>
                    </div>
                  </div>

                  <div v-if="row.item.geraAnomalia == 3" class="mb-3">
                    <b-form-group
                      label="Script validação"
                      label-for="ScriptPythonValidation"
                    >
                      <b-row v-if="userMaster">
                        <b-col cols="4">
                          <b-form-select
                            id="geraAnomalia"
                            class="select-boolean"
                            :options="optionsScriptValidation"
                            v-model="
                              row.item.predefinedScriptValidation
                                .predefinedScriptId
                            "
                            @change="
                              changePredefined(
                                row.item.predefinedScriptValidation,
                                row.item.scriptPythonValidation
                              )
                            "
                          ></b-form-select>
                        </b-col>
                      </b-row>
                      <div
                        v-if="
                          row.item.predefinedScriptValidation
                            .predefinedScriptId != 0
                        "
                      >
                        <predefined-script-form
                          :predefinedScriptId.sync="
                            row.item.predefinedScriptValidation
                              .predefinedScriptId
                          "
                          :script.sync="row.item.scriptPythonValidation"
                          :fields.sync="fillActiveList"
                          :model.sync="row.item.predefinedScriptValidation"
                        ></predefined-script-form>
                      </div>
                      
                      <custom-codemirror
                        class="mt-4"
                        id="ScriptPythonValidation"
                        :model.sync="row.item.scriptPythonValidation"
                        :readonly="
                          row.item.predefinedScriptValidation.predefinedScriptId !=
                          0
                            ? false
                            : userMaster
                        "
                      />
                    </b-form-group>
                    <b-form-group
                      label="Script processamento"
                      label-for="ScriptPythonProcess"
                    >
                      <b-row v-if="userMaster">
                        <b-col cols="4">
                          <b-form-select
                            id="geraAnomalia"
                            class="select-boolean"
                            :options="optionsScriptProcess"
                            v-model="
                              row.item.predefinedScriptProcess
                                .predefinedScriptId
                            "
                            @change="
                              changePredefined(
                                row.item.predefinedScriptProcess,
                                row.item.scriptPythonProcess
                              )
                            "
                          ></b-form-select>
                        </b-col>
                      </b-row>
                      <div
                        v-if="
                          row.item.predefinedScriptProcess.predefinedScriptId !=
                          0
                        "
                      >
                        <predefined-script-form
                          :predefinedScriptId.sync="
                            row.item.predefinedScriptProcess.predefinedScriptId
                          "
                          :script.sync="row.item.scriptPythonProcess"
                          :fields.sync="fillActiveList"
                          :model.sync="row.item.predefinedScriptProcess"
                        ></predefined-script-form>
                      </div>
                      <custom-codemirror
                        class="mt-4"
                        :readonly="
                          row.item.predefinedScriptProcess.predefinedScriptId != 0
                            ? false
                            : userMaster
                        "
                        id="ScriptPythonProcess"
                        :model.sync="row.item.scriptPythonProcess"
                      />
                    </b-form-group>

                    <b-form-group
                      label="Script pós-processamento"
                      label-for="ScriptPythonAfterProcess"
                    >
                      <b-row v-if="userMaster">
                        <b-col cols="4">
                          <b-form-select
                            id="geraAnomalia"
                            class="select-boolean"
                            :options="optionsScriptPosProcess"
                            v-model="
                              row.item.predefinedScriptAfterProcess
                                .predefinedScriptId
                            "
                            @change="
                              changePredefined(
                                row.item.predefinedScriptAfterProcess,
                                row.item.scriptPythonAfterProcess
                              )
                            "
                          ></b-form-select>
                        </b-col>
                      </b-row>
                      <div
                        v-if="
                          row.item.predefinedScriptAfterProcess
                            .predefinedScriptId != 0
                        "
                      >
                        <predefined-script-form
                          :predefinedScriptId.sync="
                            row.item.predefinedScriptAfterProcess
                              .predefinedScriptId
                          "
                          :script.sync="row.item.scriptPythonAfterProcess"
                          :fields.sync="fillActiveList"
                          :model.sync="row.item.predefinedScriptAfterProcess"
                        ></predefined-script-form>
                      </div>
                      <custom-codemirror
                        class="mt-4"
                        id="ScriptPythonAfterProcess"
                        :model.sync="row.item.scriptPythonAfterProcess"
                        :readonly="
                          row.item.predefinedScriptAfterProcess
                            .predefinedScriptId != 0
                            ? false
                            : userMaster
                        "
                      />
                    </b-form-group>
                  </div>

                  <div v-if="canShowPostCalculateScript(row.item)">
                    <label for="">Script cálculo pós processamento</label>
                    <b-row v-if="userMaster">
                      <b-col cols="4">
                        <b-form-select
                          id="geraAnomalia"
                          class="select-boolean"
                          :options="optionsScriptCalculate"
                          v-model="
                            row.item.predefinedScriptCalculate
                              .predefinedScriptId
                          "
                          @change="
                            changePredefined(
                              row.item.predefinedScriptCalculate,
                              row.item.postCalculationScript
                            )
                          "
                        ></b-form-select>
                      </b-col>
                    </b-row>
                    <div
                      v-if="
                        row.item.predefinedScriptCalculate.predefinedScriptId !=
                        0
                      "
                    >
                      <predefined-script-form
                        :predefinedScriptId.sync="
                          row.item.predefinedScriptCalculate.predefinedScriptId
                        "
                        :script.sync="row.item.postCalculationScript"
                        :fields.sync="fillActiveList"
                        :model.sync="row.item.predefinedScriptCalculate"
                      ></predefined-script-form>
                    </div>
                    <custom-codemirror
                      class="mt-4"
                      id="PostCalculationScript"
                      :readonly="
                        row.item.predefinedScriptCalculate.predefinedScriptId !=
                        0
                          ? false
                          : userMaster
                      "
                      :model.sync="row.item.postCalculationScript"
                    />
                  </div>
                  <div v-if="row.item.tipo == 22">
                    <sub-form-config
                      :subForm.sync="row.item.subForm"
                      :companyOptions="companyOptions"
                      :profiles="profiles"
                      :optionsProfiles="optionsProfiles"
                    ></sub-form-config>
                  </div>
                </b-card>
              </b-td>
            </b-tr>

            <b-tr class="b-table-details" v-if="row.detailsShowing">
              <b-td :colspan="tableFieldsCampos.length">
                <b-card>
                  <div
                    v-if="row.item.tipo == 7 || row.item.tipo == 13"
                    class="mt-4"
                  >
                    <h4>
                      {{ $t("checklist.form.fieldValues") }}:
                      {{ row.item.nome }}
                    </h4>
                    <!-- ivan default value  getValuesDropdownOptions -->
                    <b-row v-if="row.item.tipo == 13">
                      <b-col sm="12" md="6">
                        <b-form-group
                          v-if="canShowPendencyOption(row.item)"
                          label="Valor padrão"
                          label-for="selectDefaultValue"
                        >
                          <b-form-select
                            id="selectDefaultValue"
                            class="select-field"
                            :options="getValuesDropdownOptions(row.item)"
                            v-model="row.item.defaultValue"
                            title="Valor que será selecionado por padrão na criação de um novo checklist"
                            v-b-tooltip.hover
                          ></b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <table-form-values
                      ref="tableValue"
                      :items="row.item.valores"
                      :allow-add-fields="allowAddFields"
                      :company-options="companyOptions"
                      :options-profiles="optionsProfiles"
                      :profiles="profiles"
                      :userMaster="userMaster"
                      :fieldType="row.item.tipo"
                    >
                    </table-form-values>
                  </div>
                </b-card>
              </b-td>
            </b-tr>
            <!-- <b-td :colspan="tableFieldsCampos.length">
              <pre class="language-json"><code>{{ row.item  }}</code></pre>
            </b-td> -->
          </template>
        </b-tbody>
      </b-table-simple>

      <b-button size="sm" @click="addFields">
        {{ $t("checklist.form.fieldAdd") }}
      </b-button>
    </b-row>

    <!-- <pre class="language-json"><code>{{ items  }}</code></pre> -->

    <!-- <div>{{ items }}</div> -->
  </b-container>
</template>

<script>
import CopyFields from "./CopyFields";
import FormSequenceControl from "./FormSequenceControl";
import PendencyGenerationNotifyDropdown from "@/components_rms/checklist/pendency/PendencyGenerationNotifyDropdown.vue";
import PendencyPriorityDropdown from "@/components_rms/checklist/pendency/PendencyPriorityDropdown.vue";
import PendencyUniqueOpenedDropdown from "@/components_rms/checklist/pendency/PendencyUniqueOpenedDropdown.vue";
import FieldTipAttachments from "@/components_rms/checklist/form/FieldTipAttachments.vue";
import CustomCodemirror from "@/components_rms/checklist/form/CustomCodemirror.vue";

export default {
  name: "TableFormFields",
  components: {
    PendencyGenerationNotifyDropdown,
    PendencyPriorityDropdown,
    PendencyUniqueOpenedDropdown,
    TableFormResequence: () => import("./TableFormResequence.vue"),
    TableFormValues: () => import("./TableFormValues.vue"),
    FieldTipAttachments,
    PendencyDueDateCrud: () =>
      import("@/components_rms/checklist/pendency/PendencyDueDateCrud.vue"),
    SingleSelect: () => import("@/components_rms/base/SingleSelect.vue"),
    SubFormConfig: () =>
      import("@/components_rms/checklist/form/subForm/SubFormConfig.vue"),
    CustomCodemirror,
    PredefinedScriptForm: () => import("./PredefinedScriptForm.vue"),
  },
  mixins: [CopyFields, FormSequenceControl],
  props: {
    items: Array,
    allowAddFields: Boolean,
    companyOptions: Array,
    optionsProfiles: Array,
    profiles: Array,
    userMaster: Boolean,
  },
  data() {
    return {
      tableRows: [],
      options: [
        { value: null, text: "Tipo" },
        { value: 1, text: "Lógico" },
        { value: 2, text: "Data" },
        { value: 3, text: "Hora" },
        { value: 4, text: "Decimal" },
        { value: 5, text: "Inteiro" },
        { value: 6, text: "Texto" },
        { value: 7, text: "Lista" },
        { value: 8, text: "Anotação" },
        { value: 9, text: "Calculado" },
        { value: 10, text: "Apenas anexos" },
        { value: 11, text: "Assinatura" },
        { value: 13, text: "Objetivo" },
        { value: 14, text: "Responsável" },
        { value: 20, text: "Veículo" },
        { value: 21, text: "OCR" },
      ],
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      optionsAnomaly: [
        { value: 1, text: "Não" },
        { value: 2, text: "Sim" },
        { value: 3, text: "Por Script" },
      ],
      optionsRememberLastValue: [
        { value: 0, text: "Não" },
        { value: 1, text: "Sim" },
      ],
      mobileInputOptions: [
        { value: 0, text: "Câmera" },
        { value: 1, text: "Galeria" },
        { value: 2, text: "Câmera e galeria" },
      ],
      tableFieldsCampos: [
        {
          label: "Id",
          key: "sequenciaExibicao",
          sortable: false,
        },
        {
          label: "Nome",
          key: "nome",
          sortable: false,
        },
        {
          label: "Tipo",
          key: "tipo",
          sortable: false,
        },
        {
          label: "Obrigatório",
          key: "obrigatorio",
          sortable: false,
        },
        {
          label: "Dica",
          key: "dica",
          sortable: false,
        },
        {
          key: "actions",
          label: "",
        },
      ],
      profileOptions: [],
      vehicleOptions: [],
      ocrOptions: [],
      optionsIntervalType: [
        { value: 0, text: "Não vence" },
        { value: 1, text: "Hora" },
        { value: 2, text: "Dia" },
        { value: 3, text: "Semana" },
        { value: 4, text: "Mês" },
        { value: 5, text: "Ano" },
      ],
      optionsScriptCalculate: [{ value: 0, text: "" }],
      optionsScriptValidation: [{ value: 0, text: "" }],
      optionsScriptProcess: [{ value: 0, text: "" }],
      optionsScriptPosProcess: [{ value: 0, text: "" }],
      configuration: {},
      // predefinedScript: {},
    };
  },

  mounted: function () {
    this.loadTableRows();
  },
  computed: {
    fillActiveList() {
      let camposAtivos = [];
      for (let campo of this.tableRows.sort(
        (c1, c2) => c1.item.sequenciaExibicao - c2.item.sequenciaExibicao
      )) {
        if (campo.item.ativo) {
          if (campo.item.tipo == 8 || campo.item.tipo == 9) {
            campo.item.obrigatorio = false;
            campo.item.permiteAnexo = false;
            campo.item.isMandatoryAttachment = false;
            campo.item.allowsDocuments = false;
            campo.item.allowsVideo = false;
          }
          camposAtivos.push(campo);
        }
      }
      return camposAtivos;
    },
  },
  created() {
    if (this.companyOptions) {
      this.options = this.companyOptions;
    }
    this.getAllProfileOptions();
    this.getAllVehicleType();
    this.getAllOcrTypes();
    this.getScriptDropdown();
    this.getConfiguration();
  },
  watch: {
    items() {
      this.loadTableRows();
    },
    companyOptions() {
      if (this.companyOptions) {
        this.options = this.companyOptions;
      }
    },
  },
  methods: {
    getConfiguration() {
      this.$apiChecklist
        .get("/formulario/getConfiguration/")
        .then((response) => {
          this.configuration = response.data;
        });
    },
    getScriptDropdown() {
      this.$apiChecklist
        .get("/predefinedScript/getAllDropdown/")
        .then((response) => {
          for (let script of response.data) {
            let opt = { value: script.id, text: script.name };
            if (script.scriptType == 0) {
              this.optionsScriptCalculate.push(opt);
            } else if (script.scriptType == 1) {
              this.optionsScriptValidation.push(opt);
            } else if (script.scriptType == 2) {
              this.optionsScriptProcess.push(opt);
            } else if (script.scriptType == 3) {
              this.optionsScriptPosProcess.push(opt);
            }
          }
        });
    },
    changePredefined(predefined, script) {
      if (predefined.predefinedScriptId == 0) {
        predefined.variables = [];
        script = "";
        this.$forceUpdate();
      }
    },

    getPendencyDueDateIntervalRangeLabel(item) {
      let text = this.$t("checklist.pendencies.timeToDueDate");
      if (item) {
        switch (item) {
          case 1:
            return `${text} (Horas)`;
          case 2:
            return `${text} (Dias)`;
          case 3:
            return `${text} (Semanas)`;
          case 4:
            return `${text} (Meses)`;
          case 5:
            return `${text} (Anos)`;
          default:
            return text;
        }
      }
      return text;
    },
    getAllProfileOptions() {
      this.$apiScheduler.get("/profile/getAll/").then((response) => {
        this.profileOptions = response.data;
      });
    },
    getAllVehicleType() {
      this.$apiVehicle.get("/vehicleType/getDropdown/").then((response) => {
        this.vehicleOptions = response.data;
      });
    },
    getAllOcrTypes() {
      this.$apiChecklist.get("/systemFieldType/OcrType/").then((response) => {
        this.ocrOptions = response.data;
      });
    },
    allowsAttachment() {
      this.item.permiteAnexo[0].permiteAnexo = true;
    },

    addTableRow(item) {
      this.tableRows.push({
        configShowing: false,
        detailsShowing: false,
        item: item,
      });
    },
    // função que adiciona os campos
    addFields() {
      let item = {
        ativo: true,
        scriptPythonAfterProcess: "",
        scriptPythonProcess: "",
        scriptPythonValidation: "",
        sequenciaExibicao: this.getNextSequenceNumber(this.items),
        obrigatorio: false,
        tipo: 6,
        nome: "",
        defaultValue: "",
        dica: "",
        pendencyGenerationNotify: false,
        pendencyPriority: 2,
        pendencyUniqueOpened: false,
        permiteAnexo: false,
        postCalculationScript: "",
        geraAnomalia: 1,
        profilePendencyId: null,
        isMandatoryAttachment: false,
        allowsDocuments: false,
        allowsVideo: false,
        rememberLastValue: false,
        attachmentMobileMode: 0,
        pendencyDueDate: {
          fieldId: 0,
          formFieldOptionId: 0,
          dueDateIntervalType: 0,
          dueDateIntervalRange: 0,
          formPendencyNotifies: [],
        },
        valores: [],
        profilesApprover: [],
        profilesViewer: [],
        responsible: [],
        vehicle: [],
        tipAttachments: [],
        subForm: {
          title: "",
          active: true,
          fields: [],
        },
        tipAttachments: [],
        predefinedScriptCalculate: {
          id: 0,
          predefinedScriptId: 0,
          Variables: [],
        },
        predefinedScriptProcess: {
          id: 0,
          predefinedScriptId: 0,
          Variables: [],
        },
        predefinedScriptAfterProcess: {
          id: 0,
          predefinedScriptId: 0,
          Variables: [],
        },
        predefinedScriptValidation: {
          id: 0,
          predefinedScriptId: 0,
          Variables: [],
        },
      };

      this.items.push(item);
      this.addTableRow(item);
      this.$forceUpdate();
    },
    cloneField(campoBase, listaCampos) {
      console.log(campoBase);
      this.copyField(campoBase, listaCampos);
      this.$forceUpdate();
    },
    // função que deleta o campo
    deleteField(row) {
      if (!row.item.id || row.item.id == 0) {
        let rowIndex = this.tableRows.indexOf(row);
        if (rowIndex >= 0) {
          this.tableRows.splice(rowIndex, 1);
        }

        let itemIndex = this.items.indexOf(row.item);
        if (itemIndex >= 0) {
          this.items.splice(itemIndex, 1);
        }
      } else {
        row.item.ativo = false;
      }

      // reordenação da sequenciaExibicao apos remover o campo
      let campos = this.fillActiveList;
      for (let i = 0; i < campos.length; i++) {
        campos[i].item.sequenciaExibicao = i + 1;
      }
    },
    displayConfig(row) {
      if (row) {
        row.configShowing = !row.configShowing;
        this.$forceUpdate();
      }
    },
    getValuesDropdownOptions(field) {
      if (!field) return [];
      if (field == null) return [];
      if (!field.valores) return [];
      if (field.valores == null) return [];
      let options = [{ value: null, text: "Nenhum" }];
      for (let fieldValue of field.valores) {
        options.push({ value: fieldValue.valor, text: fieldValue.valor });
      }
      return options;
    },
    loadTableRows() {
      this.tableRows = [];
      if (this.items) {
        if (this.items.length > 0) {
          this.items.forEach((item) => {
            this.addTableRow(item);
          });
        }
      }
      this.$forceUpdate();
    },
    setPossuiCamposAdicionais(fieldValueRow) {
      if (fieldValueRow) {
        fieldValueRow.toggleDetails();
        fieldValueRow.item.possuiCamposAdicionais =
          !fieldValueRow.item.possuiCamposAdicionais;
      }
    },
    canShowAttachmentOption(field) {
      switch (field.tipo) {
        case 8:
          return false;
      }
      return true;
    },
    canShowObrigatoryOption(field) {
      switch (field.tipo) {
        case 9:
          return false;
        case 8:
          return false;
      }
      return true;
    },
    canShowPendencyOption(field) {
      switch (field.tipo) {
        case 8:
          return false;
      }
      return true;
    },
    canShowPostCalculateScript(field) {
      switch (field.tipo) {
        case 9:
          return true;
      }
      return false;
    },
    canShowTipOption(field) {
      switch (field.tipo) {
        case 8:
          return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
/* .container-field {
    min-width: 1200px;
  } */

.input-name {
  min-width: 200px;
}
.input-tip {
  min-width: 200px;
}
.select-boolean {
  min-width: 75px;
}
.select-field {
  min-width: 100px;
}
.table-responsive {
  overflow: visible !important;
}
</style>
